import React from 'react';
import { Link } from 'react-scroll';
import './pages.css';
import './mshops.css';
import ArrowRight from '../Components/ArrowRights.js';
import bgmshops from '../images/bglegal.webp';

function TryOnIndex() {
    return (
        <>
            <section className='mshops pagetryon' style={{ backgroundImage: `url(${bgmshops})` }} name='bgmshops'>
                <div className='content'>
                        <div className='flexIndex'>
                            <div className='colIndex'>
                            <p className='subtitles'>Virtual Try-On AI</p>
                            <div className='titles'>
                                <h2>AI INDEX<div className='registered'>®</div><sub>-</sub></h2>
                                <ArrowRight className="custom-arrow" />
                                <span className='bajada'>Somos una agencia digital radicada en Argentina. Nuestra tripulación está conformada por un equipo de profesionales que combinan diseño, tecnología y creatividad para resolver las necesidades de comunicación online de cada empresa.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id='lite' className='mshops pagesIndex planesIndex'>
                
            </section>
        </>
    );
}
export default TryOnIndex;